var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padlet-cards-list",attrs:{"role":"list","data-turbolinks":"false"}},_vm._l((_vm.sortedWalls),function(wall){return _c('padlet-card',{key:wall.id,attrs:{"wall":wall,"role":"listitem","actions":_vm.actions}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }